export function getDefaultSelectedPropertyId(properties) {
  return properties[0]?.id ?? '';
}

export function findSelectedProperty(properties, selectedPropertyId) {
  if (!selectedPropertyId) {
    return null;
  }

  return properties.find((property) => String(property.id) === String(selectedPropertyId)) || null;
}

export function getPrimaryEnterpriseContext(currentUser, properties) {
  return currentUser?.primary_enterprise || properties[0]?.enterprise || null;
}